import { subDays } from "date-fns";
import axios from "../../../utils/axios";
import {
    handleFormatDatePickerValue,
    handleRemoveEmptyParamFromQueryParams,
} from "../../../utils/helpers";

export const RECENT_SESSIONS_LOOKBACK_DAYS = 30;

export async function fetchUpcomingSessions(sessionHistoryId?: string) {
    const response = await axios.get(`/sessions/upcoming`, {
        params: handleRemoveEmptyParamFromQueryParams({
            session_history_id: sessionHistoryId,
            from_date: handleFormatDatePickerValue(
                subDays(new Date(), RECENT_SESSIONS_LOOKBACK_DAYS)
            ),
        }),
    });
    return response.data;
}
